import React from 'react';
import './TransferDetails.scss';

/** @import { TransferDetailsProps } from './TransferDetailsTypes' */

export const TransferDetails = (/** @type {TransferDetailsProps} */ { amount, description, label }) => (
    <div className={"transferContainer"}>
        <div className={"label"}>{label}</div>
        <div className={"amount"}>{amount}</div>
        <div className={"description"}>{description}</div>
        <div> <br/></div>
    </div>
);